window.application.register("modal", 
	
	//<div data-controller="modal" class="pointer-events-none fixed z-10 inset-0 overflow-y-auto">
  	//<div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    //<div data-target="modal.shade" data-action="click->modal#hide" class="text-normal ease-in duration-200 opacity-0 fixed inset-0 transition-opacity">
    //<div class="absolute inset-0 bg-black opacity-75"></div>
    //</div>
    //<div data-target="modal.closeBtn" class="hidden absolute w-full z-50">
    //<div class="w-full max-w-screen-md m-auto relative">
    //<i data-action="click->modal#hide" class="fa fas fa-times-circle text-white text-3xl right-0 cursor-pointer absolute mt-10 mr-3"></i>
    //</div>
    //</div>
    //<div data-target="modal.panel" class="opacity-0 translate-y-4 sm:scale-95 inline-block align-bottom shadow-xl transform transition-all sm:my-8 w-full  md:max-w-screen-md text-left">
    //</div>
  	//</div>
	//</div>

	class extends Stimulus.Controller {
		static get targets() {
		  return [ "shade", "panel", "closeBtn"]
		}

		initialize(){
			this.origParent = this.element.parentNode;
		}

		connect(){
			this.element[this.identifier] = this;
			window.modal = this;
			window.removeEventListener("wheel", this.scroll.bind(this));
			window.addEventListener('popstate', this.onPopState.bind(this));
			this.isOpen = false;
			this.hideCloseBtn();
		}

		scroll(e){
			if(this.isOpen){
				if(e.target != this.panelTarget){
					
					// this.element.scrollTop += e.deltaY;	
				}
			}
		}

		onPopState(e){
			if(this.isOpen) {
			    this.hide();
				return false;
			}
			window.history.back();
			return true;
		}

		showCloseBtn(){
			this.closeBtnTarget.classList.remove('hidden');
		}

		hideCloseBtn(){
			this.closeBtnTarget.classList.add('hidden');
		}

		show(el, parent, trigger){
			if(parent){
				parent.appendChild(this.element);
			}
			if(trigger){
				this.trigger = trigger;
			}else{
				this.trigger = null;
			}
			setTimeout(()=>{
				this.element.classList.remove('pointer-events-none');
				this.shadeTarget.classList.remove('ease-in');
				this.shadeTarget.classList.remove('duration-200');
				this.shadeTarget.classList.remove('opacity-0');

				this.shadeTarget.classList.add('ease-out');
				this.shadeTarget.classList.add('duration-300');
				this.shadeTarget.classList.add('opacity-75');
				this.panelTarget.classList.add('opacity-100');
				this.panelTarget.classList.add('translate-y-0');
				this.panelTarget.classList.add('sm:scale-100');
				
				this.panelTarget.classList.remove('opacity-0');
				this.panelTarget.classList.remove('translate-y-4');
				this.panelTarget.classList.remove('sm:scale-95');
				this.panelTarget.innerHTML = ''; 
				this.panelTarget.appendChild(el);
				if(el.classList && el.classList.contains("hidden")){
					el.classList.remove("hidden");
				}
				this.showCloseBtn();
				document.body.classList.add('overflow-hidden');
				// window.location.hash = 'modal';
				this.isOpen = true;
				var event = new CustomEvent("modal:opened");
				event.trigger = this.trigger;
				window.dispatchEvent(event);
				window.history.pushState({}, window.document.title, window.location.href);
			}, 1);	
		}

		hide(){

			setTimeout(()=>{
				this.element.classList.add('pointer-events-none');
				this.shadeTarget.classList.add('ease-in');
				this.shadeTarget.classList.add('duration-200');
				this.shadeTarget.classList.add('opacity-0');
				this.shadeTarget.classList.remove('ease-out');
				this.shadeTarget.classList.remove('duration-300');
				this.shadeTarget.classList.remove('opacity-75');

				this.panelTarget.classList.remove('opacity-100');
				this.panelTarget.classList.remove('translate-y-0');
				this.panelTarget.classList.remove('sm:scale-100');
				this.panelTarget.classList.add('opacity-0');
				this.panelTarget.classList.add('translate-y-4');
				this.panelTarget.classList.add('sm:scale-95');
				this.isOpen = false;
				this.hideCloseBtn();
				setTimeout(()=>{
					try{

						this.origParent.appendChild(this.element);
						document.body.classList.remove('overflow-hidden');
						if(this.trigger && this.trigger.data.get('clone') == "false"){
							// let modal trigger handle destroying the content
						}else{
							this.panelTarget.innerHTML = '';							
						}						
					}catch(err){
						console.log(err);
					}
					var event = new CustomEvent("modal:closed");
					event.trigger = this.trigger;
					window.dispatchEvent(event);
				},200);
			},1);
		}		

		disconnect(){
			try{
				this.tearDown();
			}catch(err){

			}
		}

		tearDown(){
			window.removeEventListener("wheel", this.scroll.bind(this));
			window.removeEventListener('popstate', this.onPopState.bind(this));
		}
	}
)